import { Logo } from "../components/Logo";
import { useTranslation } from "react-i18next";
import { LanguageToggle } from "../components/LanguageToggle";

export const AuthLayout = ({ children, title, subtitle }) => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary via-primary/90 to-primary/80 p-12 flex-col justify-between relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-72 h-72 bg-primary-foreground rounded-full blur-3xl" />
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-primary-foreground rounded-full blur-3xl" />
        </div>

        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <span className="text-2xl font-bold text-primary-foreground">
              PayLink 
              <span> </span>
              <span className="text-sm">
                 by Negdi
              </span>
            </span>
          </div>
        </div>

        <div className="relative z-10 space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-foreground leading-tight">
            {t("titleLine1")}
            <br />
            {t("titleLine2")}
          </h1>
          <p className="text-xl text-primary-foreground/80 max-w-md">
            {t("titleDescription")}
          </p>
        </div>

        <div className="relative z-10 flex items-center gap-8 text-primary-foreground/60">
          <div className="text-sm">
            <span className="block text-2xl font-bold text-primary-foreground">
              {t("usersValue")}
            </span>
            {t("usersLabel")}
          </div>
          <div className="h-10 w-px bg-primary-foreground/20" />
          <div className="text-sm">
            <span className="block text-2xl font-bold text-primary-foreground">
              {t("processedValue")}
            </span>
            {t("processedLabel")}
          </div>
          <div className="h-10 w-px bg-primary-foreground/20" />
          <div className="text-sm">
            <span className="block text-2xl font-bold text-primary-foreground">
              {t("uptimeValue")}
            </span>
            {t("uptimeLabel")}
          </div>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="flex-1 flex flex-col">
        <header className="flex items-center justify-between px-6 lg:p-8">
          <div className="lg:hidden">
            <Logo />
          </div>
          <div className="lg:ml-auto">
            <LanguageToggle />
          </div>
        </header>

        <main className="flex-1 flex items-center justify-center p-6 lg:p-12">
          <div className="w-full max-w-md space-y-8 animate-fade-up">
            <div>
              <Logo />
            </div>
            <div className="text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground">
                {title}
              </h2>
              {/* <p className="mt-2 text-muted-foreground">{subtitle}</p> */}
            </div>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
